export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID
export const PAYPAL_APP_SECRET = process.env.PAYPAL_APP_SECRET
export const base_url = 'https://www.backend.dailydeal.io/api/'
// export const base_url =  process.env.BASE_URL + '/api/'
// export const base_url = 'http://localhost:3001/api/'
